export const BLOB_ID = 'blob';
